var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nested-drawer", {
    staticClass: "map-sidebar",
    attrs: { items: _vm.sidebarPanels, width: 350, "menu-width": 50 },
    model: {
      value: _vm.activePanel,
      callback: function ($$v) {
        _vm.activePanel = $$v
      },
      expression: "activePanel",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }